import {action, computed, observable} from 'mobx';

import AssetModel from 'udemy-django-static/js/asset/asset.mobx-model';
import {ASSET_TYPE} from 'udemy-django-static/js/asset/constants';
import {AutomatedReviewTestApiData} from 'udemy-django-static/js/lab-manage/types';
import {labTasksApiUrl} from 'udemy-django-static/js/labs/apis';
import BaseLabResource from 'udemy-django-static/js/labs/base-lab-resource.mobx-model';

import {ALR_UI_MODE} from './constants';

export class AutomatedReviewTest extends BaseLabResource {
    @observable declare id: number;
    @observable declare testTitle: string;
    @observable declare successMessage: string;
    @observable declare errorMessage: string;
    @observable declare asset?: AssetModel;
    @observable declare labTaskId: number;
    @observable declare labTaskLabId: number;
    @observable declare labTaskLabAssetsUrl: string;
    @observable declare isForOpenChallenge: boolean;
    @observable uiMode: string;

    constructor(data: AutomatedReviewTestApiData, labTaskId: number, labTaskLabId: number, labTaskLabAssetsUrl: string, uiMode?: string) {
        super(data);
        
        this.labTaskId = labTaskId;
        this.labTaskLabId = labTaskLabId;
        this.labTaskLabAssetsUrl = labTaskLabAssetsUrl;
        this.uiMode = uiMode ?? ALR_UI_MODE.CODE_EDITOR;
    }

    get apiDataMap() {
        return {
            id: 'id',
            testTitle: 'test_title',
            successMessage: 'success_message',
            errorMessage: 'error_message',
            isForOpenChallenge: {
                source: 'is_for_open_challenge',
                defaultValue: false,
            },
            asset: {
                source: 'asset',
                map: (asset: AssetModel) => {
                    if (!asset) {
                        return;
                    }
                    return new AssetModel(asset);
                },
            },
        };
    }

    // @ts-expect-error the EditableApiModel expects type 'void'
    get editableFieldsMap() {
        return new Map([
            ['testTitle', 'test_title'],
            ['successMessage', 'success_message'],
            ['errorMessage', 'error_message'],
            ['isForOpenChallenge', 'is_for_open_challenge'],
        ]);
    }

    // @ts-expect-error the EditableApiModel expects type 'void'
    get resourceUrl() {
        return `${labTasksApiUrl(this.labTaskLabId)}${this.labTaskId}/automated-review-test/${
            this.id
        }/`;
    }

    get assetUrl() {
        return this.labTaskLabAssetsUrl;
    }

    @computed
    get resourceAssetUrl() {
        const assetsUrl = this.assetUrl;
        // @ts-expect-error type is not defined in 'AssetModel'
        if (this.asset && assetsUrl && this.asset.type === ASSET_TYPE.SOURCE_CODE) {
            return `${assetsUrl}${this.asset.id}/`;
        }
    }

    @action
    setUIMode(uiMode: string) {
        this.uiMode = uiMode;
    }

    @action
    removeAsset() {
        this.asset = undefined;
    }
}
